<template>
<EmptyPane image="/folder.svg" text="Select a folder" />
</template>
